import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { GameProvider } from './contexts/GameContext.tsx'
import { SoundProvider } from './contexts/SoundContext.tsx'
import { PostHogProvider } from './providers/PostHogProvider.tsx'
import { PostHogErrorBoundary } from 'posthog-js/react'
import { ErrorFallback } from './components/ErrorFallback.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider>
      <PostHogErrorBoundary fallback={ErrorFallback}>
        <SoundProvider>
          <GameProvider>
            <App />
          </GameProvider>
        </SoundProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>,
)
